const topicTags = [
  { name: '#顶流男星夜会', hot: '128万讨论', color: 'bg-primary-100 text-primary-700' },
  { name: '#企业家言论', hot: '120万讨论', color: 'bg-accent-100 text-accent-700' },
  { name: '#综艺争执', hot: '112万讨论', color: 'bg-secondary-100 text-secondary-700' },
  { name: '#热剧收视率', hot: '88万讨论', color: 'bg-primary-100 text-primary-700' },
  { name: '#主播翻车', hot: '76万讨论', color: 'bg-accent-100 text-accent-700' },
  { name: '#吃瓜大赛', hot: '54万讨论', color: 'bg-secondary-100 text-secondary-700' },
  { name: '#明星婚姻', hot: '48万讨论', color: 'bg-primary-100 text-primary-700' },
  { name: '#新剧吐槽', hot: '42万讨论', color: 'bg-accent-100 text-accent-700' },
  { name: '#电竞吃瓜', hot: '36万讨论', color: 'bg-secondary-100 text-secondary-700' },
  { name: '#海外娱乐', hot: '31万讨论', color: 'bg-primary-100 text-primary-700' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            🏷️ 话题广场
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            全网热门话题标签，点击探索你感兴趣的瓜
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicTags.map((tag, i) => (
            <a
              key={i}
              href="#topics"
              onClick={(e) => e.preventDefault()}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer hover:scale-105 ${tag.color}`}
            >
              <span className="whitespace-nowrap">{tag.name}</span>
              <span className="text-[11px] opacity-70 whitespace-nowrap">{tag.hot}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}